var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstVerificationErrorSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8923 18.4784L20.5231 23.6318H18.6769L18.3077 18.4784V9.59961H20.8923V18.4784ZM19.6 26.3638C20.1949 26.3638 20.6769 26.5501 21.0462 26.9226C21.4154 27.2951 21.6 27.7815 21.6 28.3817C21.6 28.9819 21.4154 29.4683 21.0462 29.8408C20.6769 30.2133 20.1949 30.3996 19.6 30.3996C19.0051 30.3996 18.5231 30.2133 18.1538 29.8408C17.7846 29.4683 17.6 28.9819 17.6 28.3817C17.6 27.7815 17.7846 27.2951 18.1538 26.9226C18.5231 26.5501 19.0051 26.3638 19.6 26.3638Z",
    fill: "#FF8C6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38.4C30.162 38.4 38.4 30.162 38.4 20C38.4 9.83796 30.162 1.6 20 1.6C9.83796 1.6 1.6 9.83796 1.6 20C1.6 30.162 9.83796 38.4 20 38.4ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#FF8C6A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstVerificationErrorSmall);
export default __webpack_public_path__ + "static/media/first-verification-error-small.06d36fa3.svg";
export { ForwardRef as ReactComponent };